import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from './component-can-deactivate';


@Injectable({
  providedIn: 'root'
})

export class CanDeactivateGuard  {
  canDeactivate(component: ComponentCanDeactivate): boolean {

    if (!component.canDeactivate()) {
      if (confirm("You have unsaved changes that will be lost if you decide to continue. \n\n Are you sure you want to leave this page?")) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
}
